import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Flex, Heading, Text } from "@radix-ui/themes";
import { ApiError, FetchError, NoAuthTokenError } from "./errors";
import { Cross2Icon } from "@radix-ui/react-icons";
export function GenericError({ error }) {
    React.useEffect(() => {
        console.error(error);
    }, [error]);
    const render = (heading, message) => (_jsxs(Flex, { p: "6", justify: "center", align: "center", direction: "column", children: [_jsx(Flex, { align: "center", justify: "center", width: "32px", height: "32px", mb: "2", style: {
                    borderRadius: "9999px",
                    backgroundColor: "var(--red-a4)",
                    color: "var(--red-a11)",
                }, children: _jsx(Cross2Icon, { width: "24px", height: "24px" }) }), _jsxs(Flex, { direction: "column", gap: "1", maxWidth: "420px", children: [_jsx(Heading, { size: "5", align: "center", mb: "1", wrap: "balance", as: "h3", children: heading }), _jsx(Text, { as: "p", align: "center", wrap: "balance", color: "gray", children: message })] })] }));
    if (error instanceof FetchError) {
        return render("Error fetching data", "An error occurred. You may need to configure CORS in the WorkOS Dashboard. " +
            "Contact your organization admin for support.");
    }
    if (error instanceof NoAuthTokenError) {
        return render("Error fetching data", "Authorization error. You likely forgot to provide an authorization " +
            "token to the Users Management Widget.");
    }
    if (error instanceof ApiError && error.status === 404) {
        // The widgets API treats all authorization errors as 404s. If there is a
        // legitimate 404, it's a bug on our end but there's currently no way to
        // distinguish between the two.
        return render("Error fetching data", "Authorization error. Contact your organization admin for support.");
    }
    return render("Error fetching data", "An unknown error occurred. If the problem continues, contact the site owner.");
}
//# sourceMappingURL=generic-error.js.map